<template>
  <div class="date-selector-cont">
    <v-text-field
        slot="activator"
        :value="date"
        :label="hint"
        append-icon="event"
        @input="inputTextDate"
        @click:append="menu = true"
        mask="####-##-##"
        hint="yyyy-mm-dd 형식으로 입력해주세요!!"
        return-masked-value
    ></v-text-field>
    <v-dialog
        v-model="menu"
        transition="scale-transition"
        width="290"
    >
      <v-date-picker
          locale="ko-KR"
          v-model="date"
          @input="selectDate"
          color="blue"></v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    hint: {
      type: String
    },
    defaultDate: {
      type: Date
    }
  },
  data() {
    return {
      menu: false,
      date: ''
    }
  },
  methods: {
    selectDate(val) {
      this.menu = false;
      this.emitValue(val);
    },
    inputTextDate (val) {
      if (val.length !== 10) return;
      this.emitValue(val);
    },
    emitValue (val) {
      this.date = val;
      this.$emit('emitDate', val);
    }
  },
  mounted () {
    if (!this.defaultDate) return;
    this.date = this.defaultDate.toISOString().substr(0, 10);
  }
}
</script>

<style lang="scss" scoped>

</style>